// extracted by mini-css-extract-plugin
export default {"text":"styles_text__kpX2R","photos":"styles_photos__AZpbL","hr":"styles_hr__6I+gA"};